// extracted by mini-css-extract-plugin
export var MenuWrapper = "menu-section-module--MenuWrapper--WDNcI";
export var buttonWrapper = "menu-section-module--button-wrapper--3Kvvh";
export var heroSubtitle = "menu-section-module--hero-subtitle--zK6Yb";
export var heroTextInner = "menu-section-module--hero-text-inner--TKoCL";
export var heroTextWrapper = "menu-section-module--hero-text-wrapper--39PLT";
export var heroTitle = "menu-section-module--hero-title--zqHgt";
export var photoWrapper = "menu-section-module--photo-wrapper--ZWVJv";
export var topShadow = "menu-section-module--top-shadow--ocpjT";